// src/modules/Button/MediaUploadButton.jsx
import React, { useState, useEffect } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../config/firebase";
import { getAuth, signInAnonymously } from "firebase/auth";

export default function MediaUploadButton({
  onUploadComplete,
  accept = "image/*",
  label = "＋",
  remainingTime = 0, // 外部から送信後カウントを受け取る
}) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [authInitialized, setAuthInitialized] = useState(false);

  // 匿名ログイン
  useEffect(() => {
    const auth = getAuth();
    signInAnonymously(auth)
      .then(() => setAuthInitialized(true))
      .catch((error) => console.error("匿名ログイン失敗:", error));
  }, []);

  // ファイル選択時の処理
  const handleFileChange = (e) => {
    const file = e.target.files[0]; // 1枚のみ
    if (!file) return;

    const storageRef = ref(storage, `uploads/${Date.now()}_${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    setUploading(true);
    setProgress(0);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (error) => {
        console.error("アップロードエラー:", error);
        setUploading(false);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setUploading(false);
        setProgress(100);
        onUploadComplete(downloadURL);
      }
    );
  };

  if (!authInitialized) return <div>準備中...</div>;

  // ボタン無効化は送信後カウント中のみ
  const isDisabled = remainingTime > 0;

  return (
    <div style={{ display: "inline-block" }}>
      <label
        style={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          padding: "8px 12px",
          backgroundColor: isDisabled ? "#94a3b8" : "#60a5fa",
          color: "white",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          pointerEvents: isDisabled ? "none" : "auto",
        }}
      >
        {uploading
          ? `アップロード中... ${progress}%`
          : remainingTime > 0
          ? `待機中... ${Math.ceil(remainingTime / 1000)}秒`
          : label}

        <input
          type="file"
          accept={accept}
          multiple={false} // 同時アップロードは1枚
          style={{ display: "none" }}
          onChange={handleFileChange}
          disabled={isDisabled}
        />
      </label>
    </div>
  );
}
